import {Component, OnInit, Input, ElementRef, ViewChild} from '@angular/core'
import {DomSanitizer, SafeResourceUrl} from '@angular/platform-browser'
import * as moment from 'moment'

@Component({
  selector: 'app-folder-view-grid-fileitem',
  templateUrl: './folder-view-grid-fileitem.component.html',
  styleUrls: ['./folder-view-grid-fileitem.component.scss'],
})
export class FolderViewGridFileitemComponent implements OnInit {
  @Input() file: any
  @Input() branding: any
  @Input() showNotifications: any
  @Input() breakpoints: Array<number>
  @Input() mobile: boolean

  showChat = false

  real_width: number
  real_height: number
  display_width: number
  display_height: number
  thumbnail: string
  fallback: string
  icon: string
  moment: string
  momenttitle: string
  pop: any

  url: SafeResourceUrl

  style = {
    container: {},
    thumbnail: {},
    video: {},
    preview: {},
  }

  constructor(private elRef: ElementRef, public sanitizer: DomSanitizer) {}

  ngOnInit() {
    let dimensions = this.file.name.match(/\d+x\d+/)
      ? this.file.name.match(/\d+x\d+/)[0].split('x')
      : [300, 0]
    let window_width =
      document.getElementsByClassName('page')[0].clientWidth ||
      window.innerWidth ||
      document.documentElement.clientWidth ||
      document.body.clientWidth
    this.real_width = dimensions[0]
    this.real_height = dimensions[1]
    this.display_width = this.getDisplayWidth(this.real_width)
    this.display_height =
      (this.display_width / this.real_width) * this.real_height
    this.moment = moment(this.file.updated).format('lll')
    this.momenttitle = moment(this.file.updated).calendar()

    this.thumbnail = this.file.type.startsWith('image')
      ? this.file.path
      : this.file.fallback
      ? this.file.fallback
      : `https://place-hold.it/${this.real_width}x${
          this.real_height
        }/${this.branding.color_shade[0].replace(
          '#',
          ''
        )}/${this.branding.color_shade[1].replace('#', '')}`

    // this.thumbnail = this.file.type.startsWith('image')
    //   ? this.file.path
    //   : this.file.fallback
    //   ? this.file.fallback
    //   : `https://screenshotapi.net/api/v1/screenshot?token=UO7BROLTMCKBAWO9SKJOT8EDGB6IBVEW&url=${encodeURI(
    //       this.file.path
    //     )}&width=${this.real_width}&height=${
    //       this.real_height
    //     }&output=image&delay=10000`

    const TYPE = this.file.type.split('/')[0]
    const ICONS = {
      image: 'photo', // photo
      text: 'html5',
      default: 'attach_file',
      video: 'videocam',
    }
    this.icon = ICONS[TYPE] || ICONS.default

    if (this.mobile) {
      let padding =
        window_width > this.real_width
          ? (window_width - this.real_width) / 2
          : 0
      padding = Math.min(60, padding)
      this.style.container = {}
      this.style.preview = {
        transform: 'scale( ' + this.display_width / this.real_width + ')',
      }
      this.style.thumbnail = {
        padding: padding + 'px',
      }
      this.style.video = {
        width: this.display_width,
        height: this.display_height,
      }
    } else {
      this.style.container = {
        width: this.display_width + 'px',
        height: `calc(${this.display_height}px + 9rem)`,
      }
      this.fallback = this.thumbnail
      this.style.thumbnail = {
        width: this.display_width + 'px',
        height: this.display_height + 'px',
      }
      this.style.video = {
        width: this.display_width,
        height: this.display_height,
      }
    }

    if (this.mobile) {
      this.listenScrollEvent()
    } else {
      // Show shorter date on small creatives
      let smallest_breakpoint = this.breakpoints[this.breakpoints.length - 1]
      if (
        this.display_width == smallest_breakpoint &&
        this.moment.length > 10
      ) {
        this.moment = moment(this.file.updated).format('DD/MM/YY')
        this.momenttitle = moment(this.file.updated).format('lll')
      }
    }
  }

  show() {
    if (!this.url)
      this.url =
        this.sanitizer.bypassSecurityTrustResourceUrl(this.file.path) ||
        this.file.path
    if (this.file.type.split('/')[0] == 'video') {
      let video = this.elRef.nativeElement.querySelector('video')
      video.currentTime = 0
      video.play()
    }
  }

  hide() {
    this.url = null
    if (this.file.type.split('/')[0] == 'video') {
      let video = this.elRef.nativeElement.querySelector('video')
      video.pause()
      video.currentTime = 0
    }
  }

  listenScrollEvent() {
    let delayedExec = function (after, fn) {
      let timer
      return function () {
        timer && clearTimeout(timer)
        timer = setTimeout(fn, after)
      }
    }

    let _ = this

    let scrollStopper = delayedExec(250, () => {
      let x = window.innerWidth / 2
      let y = window.innerHeight / 2
      let element = document.elementFromPoint(x, y).closest('a.fileitem')

      if (element && element.id == this.file.name) this.show()
      else this.hide()
    })

    document.addEventListener('scroll', scrollStopper)
  }

  getDisplayWidth(realWidth) {
    let rect = this.elRef.nativeElement.parentElement.getBoundingClientRect()
    let width = realWidth > rect.width ? rect.width : realWidth
    if (!this.breakpoints) {
      return width
    }
    if (width <= this.breakpoints[this.breakpoints.length - 1])
      return this.breakpoints[this.breakpoints.length - 1]
    for (var i = 0; i < this.breakpoints.length - 1; i++) {
      if (width >= this.breakpoints[i]) return this.breakpoints[i]
    }
    return width > this.breakpoints[this.breakpoints.length - 1]
      ? this.breakpoints[this.breakpoints.length - 1]
      : width
  }
}



// WEBPACK FOOTER //
// /Users/axel/Sites/Bannerboy/Internal/attaboy-angular/src/app/folder/folder-view/folder-view-grid/folder-view-grid-fileitem/folder-view-grid-fileitem.component.ts